// extracted by mini-css-extract-plugin
export default {"info":"style_info__-9lUr","eventTitle":"style_eventTitle__W0Jen","dateInscription":"style_dateInscription__5So9+","section":"style_section__EiNr8"};